module.exports = __webpack_public_path__ + "ecb2bfe45cc30a510ec630163baecf21.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-104.png
// module id = 100
// module chunks = 0